export default {
    SIXTY_LESS: '60-less',
    SIXTY: '60',
    ONE_HUNDRED: '100',
    ONE_HUNDRED_PLUS: '100-plus',
};
